import React, { Component, Suspense } from 'react';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import { CSpinner } from '@coreui/react-pro';
import TechServiceSingleReport from './views/tech-service/TechServiceSingleReport';
import { isExternalUI } from './utils';
import './scss/style.scss';

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'));
const BlankLayout = React.lazy(() => import('./layout/BlankLayout'));
const ExternalLayout = React.lazy(() => import('./layout/ExternalLayout'));

class App extends Component {
  render(): JSX.Element {
    return (
      <HashRouter>
        <Suspense fallback={<CSpinner color="primary" />}>
          <Routes>
            <Route path="/" element={<Navigate to={isExternalUI() ? '/external' : '/dashboard'} />} />
            {isExternalUI() ? <Route path="/external/*" element={<ExternalLayout />} /> : <Route path="/dashboard/*" element={<DefaultLayout />} />}
            <Route path="/auth/*" element={<BlankLayout />} />
            <Route path="/report/tech-service/:id" element={<TechServiceSingleReport />} />
          </Routes>
        </Suspense>
      </HashRouter>
    );
  }
}

export default App;
